import styled from 'styled-components';
import { Text, mixins, colors, media, fonts } from '@custom-components';

function resolveArrowPosition(pickerPosition, focusedInput) {
  switch (pickerPosition) {
    case 'center':
      return `left: 50%; transform: translateX(-50%);`;
    case 'right':
      return `right: 100px;`;
    case 'left':
    default:
      return `left: ${focusedInput === 'endDate' ? '100px' : '50px'};`;
  }
}

export const DayPickerWrapper = styled.div`
  position: absolute;
  ${({ pickerPosition }) => {
    switch (pickerPosition) {
      case 'center':
        return `left: 50%; transform: translateX(-50%);`;
      case 'right':
        return `right: 0px;`;
      case 'left':
      default:
        return `left: 0px;`;
    }
  }};
  ${({ fullScreen }) => (fullScreen ? `left: 50%; transform: translateX(-50%);` : null)};
  margin-top: 15px;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  z-index: 3;
  &::after {
    ${({ noArrow, focusedInput, pickerPosition }) =>
      !noArrow &&
      `
    content: '';
    ${resolveArrowPosition(pickerPosition, focusedInput)};
    position: absolute;
    height: ${mixins.pxToRem(15)};
    width: ${mixins.pxToRem(15)};
    background: ${colors.colorWhite};
    transform: rotate(45deg);
    top: -${mixins.pxToRem(5)};
    `};
  }
`;

export const CopyMini = styled(Text.CopyMini)`
  background: ${colors.colorGrey05};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
`;

export const ButtonsContainer = styled.div`
  padding-bottom: 14px;
`;

export const Wrapper = styled.div`
  position: relative;
  flex-grow: 1;

  button {
    border: none;
  }

  .CalendarDay {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    font-size: ${mixins.pxToRem(12)};
    ${media.greaterThan('370px')`font-size: ${mixins.pxToRem(14)};`} text-align: center;
    padding-top: 2px;
  }

  .CalendarDay:active {
    outline: 0;
  }

  .CalendarDay__defaultCursor {
    cursor: default;
  }

  .CalendarDay__default {
    color: ${colors.colorGrey};
    background: #fff;
  }

  .CalendarDay__default:hover {
    background: ${colors.colorGrey05};
    color: inherit;
  }

  .CalendarDay__hovered_offset {
    background: ${colors.colorGrey04};
    color: inherit;
  }

  .CalendarDay__outside {
    background: #fff;
    color: ${colors.colorGrey};
  }

  .CalendarDay__blocked_minimum_nights {
    background: #fff;
    color: #cacccd;
  }

  .CalendarDay__blocked_minimum_nights:active,
  .CalendarDay__blocked_minimum_nights:hover {
    background: #fff;
    color: #cacccd;
  }

  .CalendarDay__highlighted_calendar {
    background: #ffe8bc;
    color: ${colors.colorGrey};
  }

  .CalendarDay__highlighted_calendar:active,
  .CalendarDay__highlighted_calendar:hover {
    background: #ffce71;
    color: ${colors.colorGrey};
  }

  .CalendarDay__selected_span {
    background: ${colors.colorBlue04};
    color: #fff;
  }

  .CalendarDay__selected_span:active,
  .CalendarDay__selected_span:hover {
    background: ${colors.colorBlue02};
    color: #fff;
  }

  .CalendarDay__last_in_range {
    border-right: ${colors.colorBlue02};
  }

  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: ${colors.colorBlue02};
    color: #fff;
  }

  .CalendarDay__hovered_span,
  .CalendarDay__hovered_span:hover {
    background: ${colors.colorBlue04};
    color: #fff;
  }

  .CalendarDay__hovered_span:active {
    background: ${colors.colorBlue04};
    color: #ffffff;
  }

  .CalendarDay__blocked_calendar,
  .CalendarDay__blocked_calendar:active,
  .CalendarDay__blocked_calendar:hover {
    background: #cacccd;
    color: #82888a;
  }

  .CalendarDay__blocked_out_of_range,
  .CalendarDay__blocked_out_of_range:active,
  .CalendarDay__blocked_out_of_range:hover {
    background: #fff;
    color: #cacccd;
  }

  .CalendarMonth {
    background: #fff;
    text-align: center;
    padding: 0 13px;
    vertical-align: top;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .CalendarMonth_table {
    border-collapse: collapse;
    margin-top: 10px;
    border-spacing: 0;
  }

  .CalendarMonth_verticalSpacing {
    border-collapse: separate;
  }

  .CalendarMonth_caption {
    color: ${colors.colorGrey};
    font-size: ${mixins.pxToRem(12)};
    ${media.greaterThan('370px')`font-size: ${mixins.pxToRem(14)};`} text-align: center;
    padding-top: 29px;
    padding-bottom: 42px;
    caption-side: initial;
  }

  .CalendarMonth_caption > strong {
    font-family: ${fonts.fontBold};
  }

  .CalendarMonth_caption__verticalScrollable {
    padding-top: 12px;
    padding-bottom: 7px;
  }
  .CalendarMonthGrid {
    background: #fff;
    text-align: left;
    z-index: 0;
  }
  .CalendarMonthGrid__animating {
    z-index: 1;
  }
  .CalendarMonthGrid__horizontal {
    position: absolute;
    left: 9px;
  }
  .CalendarMonthGrid__vertical {
    margin: 0 auto;
  }
  .CalendarMonthGrid__vertical_scrollable {
    margin: 0 auto;
    overflow-y: scroll;
  }

  .CalendarMonthGrid_month__horizontal {
    display: inline-block;
    vertical-align: top;
    min-height: 100%;
  }

  .CalendarMonthGrid_month__hideForAnimation {
    position: absolute;
    z-index: -1;
    opacity: 0;
    pointer-events: none;
  }

  .CalendarMonthGrid_month__hidden {
    visibility: hidden;
  }

  .DayPickerNavigation {
    position: relative;
    z-index: 2;
  }

  .DayPickerNavigation__horizontal {
    height: 0;
  }

  .DayPickerNavigation__verticalDefault {
    position: absolute;
    width: 100%;
    height: 52px;
    bottom: 0;
    left: 0;
  }

  .DayPickerNavigation__verticalScrollableDefault {
    position: relative;
  }

  .DayPickerNavigation_button {
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background: none;
    padding: 0;
    margin: 0;
    position: absolute;
    top: 25px;
  }

  .DayPickerNavigation_button:first-child {
    left: 22px;
  }

  .DayPickerNavigation_button:last-child {
    right: 22px;
  }

  .DayPickerNavigation_button__default {
    background-color: #fff;
    color: #757575;
  }

  .DayPickerNavigation_button__default:focus,
  .DayPickerNavigation_button__default:hover {
  }

  .DayPickerNavigation_button__default:active {
    background: #f2f2f2;
  }

  .DayPickerNavigation_button__horizontalDefault {
    position: absolute;
    top: 18px;
    line-height: 0.78;
    border-radius: 3px;
    padding: 6px 9px;
  }

  .DayPickerNavigation_leftButton__horizontalDefault {
    left: 22px;
  }

  .DayPickerNavigation_rightButton__horizontalDefault {
    right: 22px;
  }

  .DayPickerNavigation_button__verticalDefault {
    padding: 5px;
    background: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    position: relative;
    display: inline-block;
    height: 100%;
    width: 50%;
  }

  .DayPickerNavigation_nextButton__verticalDefault {
    border-left: 0;
  }

  .DayPickerNavigation_nextButton__verticalScrollableDefault {
    width: 100%;
  }

  .DayPickerNavigation_svg__horizontal {
    height: 19px;
    width: 19px;
    fill: #82888a;
  }

  .DayPickerNavigation_svg__vertical {
    height: 42px;
    width: 42px;
    fill: ${colors.colorGrey};
  }

  .DayPicker {
    background: #fff;
    position: relative;
    text-align: left;
    font-family: ${fonts.fontRegular};
  }

  .DayPicker__horizontal {
    background: #fff;
  }

  .DayPicker__verticalScrollable {
    height: 100%;
  }

  .DayPicker__hidden {
    visibility: hidden;
  }

  .DayPicker__withBorder {
    ${({ fullScreen }) => (!fullScreen ? `box-shadow: 0px 0px 22.5px 0px rgba(0, 0, 0, 0.05);` : null)};
    border-radius: 0;
  }

  .DayPicker_portal__horizontal {
    box-shadow: none;
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .DayPicker_portal__vertical {
    position: initial;
  }

  .DayPicker_focusRegion {
    outline: 0;
  }

  .DayPicker_calendarInfo__horizontal,
  .DayPicker_wrapper__horizontal {
    display: inline-block;
    vertical-align: top;
  }

  .DayPicker_weekHeaders {
    position: relative;
  }

  .DayPicker_weekHeaders__horizontal {
    margin-left: 9px;
  }

  .DayPicker_weekHeader {
    color: #757575;
    position: absolute;
    top: 68px;
    z-index: 2;
    padding: 0 13px;
    text-align: left;
  }

  .DayPicker_weekHeader__vertical {
    left: 50%;
  }

  .DayPicker_weekHeader__verticalScrollable {
    top: 0;
    display: table-row;
    border-bottom: 1px solid #dbdbdb;
    background: #fff;
    margin-left: 0;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .DayPicker_weekHeader_ul {
    list-style: none;
    margin: 1px 0;
    padding-left: 0;
    padding-right: 0;
    font-size: ${mixins.pxToRem(12)};
    ${media.greaterThan('370px')`font-size: ${mixins.pxToRem(14)};`};
  }

  .DayPicker_weekHeader_li {
    display: inline-block;
    text-align: center;
  }

  .DayPicker_weekHeader_li > small {
    font-size: ${mixins.pxToRem(12)};
    ${media.greaterThan('370px')`font-size: ${mixins.pxToRem(14)};`};
  }

  .DayPicker_transitionContainer {
    position: relative;
    overflow: hidden;
    border-radius: 3px;
  }

  .DayPicker_transitionContainer__horizontal {
    -webkit-transition: height 0.2s ease-in-out;
    -moz-transition: height 0.2s ease-in-out;
    transition: height 0.2s ease-in-out;
  }

  .DayPicker_transitionContainer__vertical {
    width: 100%;
  }

  .DayPicker_transitionContainer__verticalScrollable {
    padding-top: 20px;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow-y: scroll;
  }

  .DateRangePicker {
    position: relative;
    display: inline-block;
    font-family: ${fonts.fontRegular};
  }

  .DateRangePicker__block {
    display: block;
  }

  .DateRangePicker_picker {
    z-index: 1;
    background-color: #fff;
    position: absolute;
    font-family: ${fonts.fontRegular};
  }

  .DateRangePicker_picker__rtl {
    direction: rtl;
  }

  .DateRangePicker_picker__directionLeft {
    left: 0;
  }

  .DateRangePicker_picker__directionRight {
    right: 0;
  }

  .DateRangePicker_picker__portal {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .DateRangePicker_picker__fullScreenPortal {
    background-color: #fff;
  }

  .DateRangePicker_closeButton {
    background: 0 0;
    color: inherit;
    font: inherit;
    line-height: normal;
    overflow: visible;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    padding: 15px;
    z-index: 2;
  }

  .DateRangePicker_closeButton:focus,
  .DateRangePicker_closeButton:hover {
    color: darken(#cacccd, 10%);
    text-decoration: none;
  }

  .DateRangePicker_closeButton_svg {
    height: 15px;
    width: 15px;
    fill: #cacccd;
  }

  .bookingSearchWidgetCon & .DayPicker__withBorder {
    right: 25% !important;
  }

  .propertySearchWidgetCon & .DayPicker__withBorder {
    right: 25% !important;
  }
`;
